import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import {
  Box,
  Button,
  HeadingText,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import { track } from '@leagueplatform/analytics';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import { CHALLENGE_CAMPAIGN_TYPE } from '#constants/analytics.constants.tsx';
import { useGetChallengeByIdData } from '#pages/challenge-landing-page/hooks/use-get-challenge-by-id-data.hook.ts';
import { TeamInviteLinkModal } from '../../team-invite-link-modal/team-invite-link-modal.component';

type InviteFriendsCTAProps = {
  teamName: string;
};

export const InviteFriendsCTA = ({ teamName }: InviteFriendsCTAProps) => {
  const { formatMessage } = useIntl();
  const { teamId, challengeId } = useParams<{
    teamId: string;
    challengeId: string;
  }>();
  const { data: challengeData } = useGetChallengeByIdData();

  const handleAnalyticsClick = () => {
    if (challengeData?.data) {
      track(
        'challenges.button_clicked.challenge_team_settings_modal.invite_friends',
        {
          team_id: teamId || '',
          team_name: teamName || '',
          health_campaign_id: challengeId || '',
          health_campaign_name: challengeData.data.title || '',
          health_campaign_type: CHALLENGE_CAMPAIGN_TYPE,
        },
      );
    }
  };

  const [displayTeamInviteLinkModal, setDisplayTeamInviteLinkModal] =
    React.useState(false);

  return (
    <>
      <Box
        css={{
          backgroundColor: '$highlightBackgroundSubdued',
          padding: '$one',
          borderRadius: '$medium',
        }}
      >
        <HeadingText level="2" size="md">
          {formatMessage({ id: 'TEAM_INVITE_HEADING' })}
        </HeadingText>
        <Box
          css={{
            marginBlockStart: '$half',
            marginBlockEnd: '$oneAndHalf',
          }}
        >
          <ParagraphText>
            {formatMessage({ id: 'TEAM_INVITE_DESCRIPTION' })}
          </ParagraphText>
        </Box>
        <Button
          width="fillContainer"
          onClick={() => {
            setDisplayTeamInviteLinkModal(true);
            handleAnalyticsClick();
          }}
        >
          {formatMessage({ id: 'INVITE' })}
        </Button>
      </Box>
      <TeamInviteLinkModal
        isOpen={displayTeamInviteLinkModal}
        onDismiss={() => setDisplayTeamInviteLinkModal(false)}
      />
    </>
  );
};
